module.exports = __webpack_public_path__ + "img/40.9cb39a87.jpg";